/**
 * @file
 * Adds a clear (×) button to inputs with the .js-clearable class.
 */
(function (Drupal, once) {
  'use strict';

  // Input types that make sense to clear. Adjust as needed.
  const SUPPORTED_TYPES = new Set([
    'text', 'search', 'email', 'url', 'tel', 'password', 'number'
  ]);

  function makeWrapper(input) {
    const wrapper = document.createElement('span');
    wrapper.className = 'clearable-input';
    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(input);
    return wrapper;
  }

  function makeButton(input) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'clearable-input__btn';
    btn.setAttribute('aria-label', Drupal.t('Clear input'));
    btn.setAttribute('title', Drupal.t('Clear'));
    // Prevent form submission when hitting Enter on the button in some browsers.
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (input.disabled || input.readOnly) {
        return;
      }
      input.value = '';
      toggleButton(btn, input);
      // Move focus back to the input and fire events so Drupal/Ajax can react.
      input.focus();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    return btn;
  }

  function toggleButton(button, input) {
    const hasValue =
      input.value !== null &&
      String(input.value).length > 0 &&
      !input.disabled &&
      !input.readOnly;
    button.classList.toggle('is-visible', hasValue);
  }

  Drupal.behaviors.inputClear = {
    attach(context) {
      // Find all opted-in inputs.
      const inputs = once('inputClear', 'input.js-clearable', context);

      inputs.forEach((input) => {
        // Guard: only on supported input types and not already wrapped by other widgets.
        if (!SUPPORTED_TYPES.has((input.getAttribute('type') || 'text').toLowerCase())) {
          return;
        }

        // Wrap input so we can position the button.
        const wrapper = makeWrapper(input);
        const btn = makeButton(input);
        wrapper.appendChild(btn);

        // Initial state.
        toggleButton(btn, input);

        // Update on user typing / programmatic changes.
        input.addEventListener('input', () => toggleButton(btn, input));
        input.addEventListener('change', () => toggleButton(btn, input));

        // UX: pressing Escape while input is focused clears it.
        input.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && !input.readOnly && !input.disabled && input.value) {
            input.value = '';
            toggleButton(btn, input);
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
            e.stopPropagation();
            e.preventDefault();
          }
        });
      });
    }
  };
})(Drupal, once);
